const styles = theme => ({
  root: {
    position: 'relative',
    display: 'block',
    border: 'none',
    margin: 0,
    padding: 0,
    boxShadow: 'none',
    textShadow: 'none'
  },
  link: {
    border: 'none',
    outline: 'none',
    userSelect: 'none'
  },
  title: {
    position: 'absolute',
    left: 0,
    top: 0,
    visibility: 'hidden'
  },
  logo: {
    display: 'block',
    margin: 0,
    border: 'none',
    padding: 0,
    width: 'auto',
    height: '100%',
    opacity: 0,
    filter: `drop-shadow(0 0 1.5px ${theme.color.secondary.main})`,
    transition: `filter ${theme.animation.time}ms ease-out`
  },
  hover: {
    '&:hover': {
      '& $logo': {
        filter: `drop-shadow(0 0 6px ${theme.color.secondary.main})`
      }
    }
  }
});

export { styles };
